import { autocompletion } from '@codemirror/autocomplete';
export function mentions(data) {
  if (data === void 0) {
    data = [];
  }
  return autocompletion({
    override: [context => {
      var word = context.matchBefore(/@(\w+)?/);
      if (!word) return null;
      if (word && word.from == word.to && !context.explicit) {
        return null;
      }
      return {
        from: word == null ? void 0 : word.from,
        options: [...data]
      };
    }]
  });
}
export var mentionsView = [mentions()];